import React from 'react';
import injectSheet from 'react-jss';

import BackgroundImageSection from '../components/BackgroundImageSection';
import Section from '../components/Section';

const styles = {
    usecase: {
        margin: '3.53rem 0.5rem',
        '& .iframe-container': {
            position: 'relative',
            margin: '0 auto',
            paddingBottom: '56.25%',
            paddingTop: 35,
            height: 0,
            overflow: 'hidden'
        },
        '& .iframe-container > iframe': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
        }
    }
};

export default injectSheet(styles)(({ classes, data }) => {
    const usecases = data.usecases.edges.map((usecase, index) => {
        return (
            <Section key={index}>
                <div
                    className={classes.usecase}
                    dangerouslySetInnerHTML={{ __html: usecase.node.html }}
                    />
            </Section>
        );
    });
    
    return (
        <div>
            <BackgroundImageSection
                sizesBackground={data.imageBackground.childImageSharp.sizes}>
                <h1>{data.contents.usecase.title}</h1>
                <p>{data.contents.usecase.description}</p>
            </BackgroundImageSection>
            {usecases}
        </div>
    );
});

export const query = graphql`
    query IndexUsecaseQuery {
        ...IndexLayoutFragment
        ...IndexUsecaseFragment
    }

    fragment IndexUsecaseFragment on RootQueryType {
        imageBackground: file(relativePath: { eq: "bg_usecase.jpg" }) {
            childImageSharp {
                sizes(maxWidth: 2000, quality: 90) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        contents: stringsToml {
            usecase {
                title
                description
            }
        }

        usecases: allMarkdownRemark(
            filter: {
                frontmatter: { type: { eq: "usecase" }}
            }, sort: {
                fields: [ frontmatter___date ],
                order: DESC
            }
        ) {
            edges {
                node {
                    html
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/usecase.js